module.exports = __webpack_public_path__ + "img/Weapon_169.e186a457.png";